<template>
  <div class="stat_boxes">
    <stat-box>
      <template #value>
        {{ statBoxCount('totalCustomers') }}
      </template>
      <template #diff>
        <span v-html="statBoxDiffIcon('totalCustomers')" />
      </template>
      <template #name>
        Total Customers
      </template>
      <template
        v-if="companyInfo"
        #chart
      >
        <apexchart
          :options="getChartOptions('totalCustomers')"
          :series="[{
            name: 'Total customers',
            data: Object.values(companyInfo.totalCustomers.data),
          }]"
          :height="chartHeight"
        />
      </template>
      <template #limitStart>
        {{ statBoxRangeLimits('totalCustomers').start }}
      </template>
      <template #limitEnd>
        {{ statBoxRangeLimits('totalCustomers').end }}
      </template>
      <template #footer>
        <div class="d-flex">
          <a
            class="ml-auto mt-2"
            href="/merchant/customers"
          >View all</a>
        </div>
      </template>
    </stat-box>
    <stat-box>
      <template #value>
        {{ statBoxCount('newCustomers') }}
      </template>
      <template #diff>
        <span v-html="statBoxDiffIcon('newCustomers')" />
      </template>
      <template #name>
        New Customers
      </template>
      <template
        v-if="companyInfo"
        #chart
      >
        <apexchart
          :options="getChartOptions('newCustomers')"
          :series="[{
            name: 'New customers',
            data: Object.values(companyInfo.newCustomers.data),
          }]"
          :height="chartHeight"
        />
      </template>
      <template #limitStart>
        {{ statBoxRangeLimits('newCustomers').start }}
      </template>
      <template #limitEnd>
        {{ statBoxRangeLimits('newCustomers').end }}
      </template>
    </stat-box>
    <stat-box>
      <template #value>
        {{ statBoxCount('lostCustomers') }}
      </template>
      <template #diff>
        <span v-html="statBoxDiffIcon('lostCustomers')" />
      </template>
      <template #name>
        Lost Customers
      </template>
      <template
        v-if="companyInfo"
        #chart
      >
        <apexchart
          :options="getChartOptions('lostCustomers')"
          :series="[{
            name: 'Lost customers',
            data: Object.values(companyInfo.lostCustomers.data),
          }]"
          :height="chartHeight"
        />
      </template>
      <template #limitStart>
        {{ statBoxRangeLimits('lostCustomers').start }}
      </template>
      <template #limitEnd>
        {{ statBoxRangeLimits('lostCustomers').end }}
      </template>
    </stat-box>
  </div>
</template>

<script>
import StatBox from "./StatBox";
import {mapGetters} from "vuex";

const chartHeight = 70;

const defaultChartOptions = {
  chart: {
    sparkline: {
      enabled: true,
    },
    animations: {
      enabled: false,
    },
  },
  stroke: {
    width: 2,
    curve: 'straight'
  },
  grid: {
    padding: {
      top: 10,
      right: 10,
      bottom: 10,
      left: 10,
    },
  },
  tooltip: {
    x: {
      show: true,
    },
    y: {
      formatter: (val) => Math.round(val),
      title: {
        formatter: () => '',
      },
    },
    marker: {
      show: false,
    },
    theme: 'statbox_tooltip',
    fixed: {
      position: 'topLeft',
    }
  },
}

const diffIcons = {
  '0': '<i class="fa fa-arrow-right"></i>',
  '-1': '<i class="fa fa-arrow-down"></i>',
  '1': '<i class="fa fa-arrow-up"></i>',
}
const diffClasses = {
  '0': 'text-warning',
  '-1': 'text-danger',
  '1': 'text-success',
}

export default {
  components: {
    StatBox,
  },
  data() {
    return {
      chartHeight,
    }
  },
  computed: {
    ...mapGetters('stripeConnectDashboard', [
      'companyInfo',
      'statBoxCount',
      'statBoxDiff',
      'statBoxDiffAmount',
      'statBoxRange',
      'statBoxRangeLimits',
    ]),
  },
  methods: {
    statBoxDiffIcon(companyInfoProperty) {
      const diff = this.statBoxDiff(companyInfoProperty);
      const diffIcon = diffIcons[diff];
      const diffAmount = this.statBoxDiffAmount(companyInfoProperty)
      const diffClass = diffClasses[diff];
      return `<strong class="${diffClass}">${diffIcon} ${diffAmount !== 0 ? diffAmount : 'No change'}</strong>`;
    },
    getChartOptions(companyInfoProperty) {
      return {
        xaxis: {
          categories: this.statBoxRange(companyInfoProperty)
        },
        ...defaultChartOptions
      };
    },
  },
}
</script>

<style lang="scss" scoped>
  .stat_boxes {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 2.313rem;
    margin-top: 2.813rem;
  }
  @media screen and (max-width: 767px) {
    .stat_boxes {
      grid-template-columns: repeat(2, 1fr);
    }
    :deep(.stat_box):first-of-type {
      grid-column: 1 / 3;
    }
  }
</style>
